export default "__VITE_ASSET__CKetID5___"